export const getFileName = (disposition: string | null): string => {
    if (disposition === null) return ''
    const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i
  
    var matches = utf8FilenameRegex.exec(disposition)
    if (matches !== null && matches[1]) return decodeURIComponent(matches[1])
    else return ''
  };